import PropTypes from 'prop-types';

const Clickable = ({ children, onClick, className, testId, style }) => (
  <span
    className={className}
    onClick={onClick}
    onKeyPress={onClick}
    role="button"
    tabIndex={-1}
    data-testid={testId}
    style={style}
  >
    {children}
  </span>
);

Clickable.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  testId: PropTypes.string,
  style: PropTypes.shape({}),
};

Clickable.defaultProps = {
  className: '',
  testId: 'clickable',
  style: {},
};

export default Clickable;
